import { cn } from '@/lib/utils'
// import { getComponentHeights } from '../utils'

export function ComponentHeader({
  children,
  className,
  emphasize = false,
  style,
  wrapperClassName,
}: {
  children: React.ReactNode
  className?: string
  wrapperClassName?: string
  emphasize?: boolean
  style?: React.CSSProperties
}) {
  // const { headerHeight } = getComponentHeights(emphasize)
  return (
    <div
      // style={{ height: headerHeight, ...style }}
      style={{ ...style }}
      className={cn(
        'w-full shrink-0 border-b pb-4',
        {
          'flex items-center rounded-lg border-none bg-foreground/75 px-5 pb-2 pt-2 dark:bg-secondary': emphasize,
        },

        wrapperClassName
      )}
    >
      <div
        className={cn(
          'flex w-full items-center justify-between gap-4',
          {
            '[&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-background dark:[&_h2]:text-foreground [&_p]:text-base [&_p]:font-light [&_p]:text-background dark:[&_p]:text-foreground':
              emphasize,
          },
          className
        )}
      >
        {children}
      </div>
    </div>
  )
}
